import axios from 'axios';

export const fetchAllUsers = () => axios.get('/api/users/');

export const sendForgotPassword = (data) => axios.post('/api/auth/forgotPassword', data);

export const resetPassword = (token, data) => axios.patch(`/api/auth/resetPassword/${token}`, data);
